interface ISSRContext {
  title: string;
  url: string;
  backend: {
    response: {
      base_url: string;
      debug: true;
      message?: string;
      request_path: string;
      status: number;
      success: boolean;
    };
    results: {
      [key: string]: any;
    };
    server_side_rendering_data: {
      cookies: {
        csrftoken: string;
        [key: string]: any;
      };
    };
  };
}

let ssrContext: ISSRContext | null = null;

export function getServerSideContext(): any {
  return ssrContext;
}

export function setServerSideContext(ctx: any) {
  ssrContext = ctx;
}
